export {atomWithStorageAccessor, clearManagedStorage, useStorageAccessor} from './ManagedStorage';

import local from './local/since-v21.30.0';
export const appLocalStorage = local['v21.30.0'];

import session from './session/since-v21.30.0';
export const appSessionStorage = session['v21.30.0'];
